import React, { Component } from 'react';
import { connect } from 'react-redux';
import Autosuggest from 'react-autosuggest';
import { setSearchParameter, setSectionTemplateSearchParameter, setOverriddingRiskFactorSearchParameter, setScorecardSearchParameters, countryAutoComplete, stateAutoComplete } from './action';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import './style.css';
// import { checkDuplicateValue } from './helper'

const getSuggestions = (value, result) => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;
    let tempResults;
    if (!result) {
        tempResults = [result]
        return tempResults
    } else {
        tempResults = result;
        return inputLength === 0 ? [] : tempResults.filter(result => (result.name) ? result.name.toLowerCase().slice(0, inputLength) === inputValue :
            result.value.toLowerCase().slice(0, inputLength)
        );
    }

};
/* 
return inputLength === 0 ? [] : tempResults.filter(result =>
    result.value.toLowerCase().slice(0, inputLength) === inputValue
); */
const renderSuggestion = suggestion => (
    <div className='sugestion-options' title={(suggestion.value) ? suggestion.value : suggestion.name}>
        {(suggestion.value) ? suggestion.value : suggestion.name}
    </div>
);
class MyAutosuggest extends Component {
    constructor() {
        super();
        this.state = {
            suggestions: [],
            value: '',
            selectedOption: [],
            financialSearch: [],
            modal: false
        }
        this.set = new Set();
        this.searchType = '';
        // this.Auth = new AuthService();
    }
    getSuggestionValue = (suggestion) => {
        this.setState({
            selectedOption: suggestion
        });
        return suggestion.value
    };
    onSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            suggestions: [],
            value: value
        }, () => {
            if (value.length > 0) {
                switch (this.props.id) {
                    case 'sectionTemplate':
                        this.props.setSectionTemplateSearchParameter(value);
                        break;
                    case 'overridding':
                        this.props.setOverriddingRiskFactorSearchParameter(value);
                        break;
                    case 'scorecardSearch':
                        this.props.setScorecardSearchParameters(value);
                        break;
                    case 'dataMappingSearch':
                        this.setState({
                            suggestions: getSuggestions(value, this.props.resultData),
                        });
                        break;
                    case 'countrySearch':
                        this.props.countryAutoComplete(value);
                        break
                    case 'stateSearch':
                        this.props.stateAutoComplete({ search: value, country: this.props.countryValue });
                        break;

                    default: this.props.setSearchParameter(value, this.props.id);
                }
            }
        })

    }

    handleAuthorization = () => {
        this.Auth.logout();
    }
    toggle = () => {
        this.setState({
            modal: !this.state.modal
        });
    }

    onSuggestionSelected = (event, { suggestion }) => {
        event.preventDefault();
        let tempfinancialSearch = []
        if (this.props.id !== 'dataMappingSearch') {
            tempfinancialSearch = [...this.state.financialSearch];
        }
        tempfinancialSearch.push(suggestion);
        this.setState({
            financialSearch: tempfinancialSearch
        }, () => {
            if (this.props.id === 'countrySearch' || this.props.id === 'stateSearch' || this.props.id === 'dataMappingSearch' || this.props.id === 'sectionTemplate' || this.props.searchType === 'riskFactorSearch' || this.props.id === 'scorecardSearch') {
                this.setState(prevState => ({
                    value: prevState.value
                }));
            } else {
                this.setState({
                    value: ''
                })
            }
        });
        this.props.searchCallback(suggestion, this.props.id, this.props.rowName);
    }
    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: []
        });
    };
    onChange = (event, { newValue }) => {
        this.setState({
            value: newValue
        })
        if (this.props.id === 'sectionTemplate') {
            this.props.searchCallback(this.state.suggestions, this.props.id);
        } else if (this.props.id === 'qualitative' || this.props.id === 'quantative') {
            this.props.searchCallback(newValue, this.props.id)
        } else if (this.props.id === 'dataMappingSearch') {
            if (!newValue) {
                this.props.searchCallback(null, this.props.id, this.props.rowName)
            }
        }
    }
    componentDidUpdate = (prevProps) => {
        if (this.props.searchResults !== prevProps.searchResults) {
            if (this.props.id === 'overridding') {
                this.setState({
                    suggestions: getSuggestions(this.props.searchKey, this.props.searchResults),
                })
            } else if (this.props.id === 'sectionTemplate' || this.props.id === 'scorecardSearch') {
                this.setState({
                    suggestions: getSuggestions(this.props.searchKey, this.props.searchResults),
                    financialSearch: []
                })
            } else if (this.props.id === 'countrySearch' || this.props.id === 'stateSearch') {
                this.setState({
                    suggestions: getSuggestions(this.state.value, this.props.searchResults),
                    financialSearch: []
                })
            } else if (this.props.searchKey.search) {
                this.setState({
                    suggestions: getSuggestions(this.props.searchKey.search, this.props.searchResults),
                    financialSearch: []
                })
            }
        }

        if (this.props.financialData !== prevProps.financialData) {
            this.setState({
                financialSearch: this.props.financialData
            })
        }
        if (this.props.financialSearch !== prevProps.financialSearch) {
            this.setState({
                financialSearch: this.props.financialSearch
            })
        } else if (this.props.nonFinancialSearch !== prevProps.nonFinancialSearch) {
            this.setState({
                financialSearch: this.props.nonFinancialSearch
            })
        }
        if (this.props.selectedValueCountry !== prevProps.selectedValueCountry) {
            if (this.props.id === 'countrySearch') {
                if (Array.isArray(this.props.selectedValueCountry)) {
                    this.setState({
                        value: (this.props.selectedValueCountry.length > 0) ? this.props.selectedValueCountry[0] : ''
                    })
                } else if (typeof this.props.selectedValueCountry === "object") {
                    this.setState({
                        value: this.props.selectedValueCountry.value
                    })
                } else {
                    this.setState({
                        value: (this.props.selectedValueCountry) ? this.props.selectedValueCountry : ''
                    })
                }
            }
        }
        if (this.props.selectedValueState !== prevProps.selectedValueState) {
            if (this.props.id == 'stateSearch') {
                if (Array.isArray(this.props.selectedValueState)) {
                    this.setState({
                        value: (this.props.selectedValueState.length > 0) ? this.props.selectedValueState[0] : ''
                    })
                } else if (typeof this.props.selectedValueState === "object") {
                    this.setState({
                        value: this.props.selectedValueState.value
                    })
                } else {
                    this.setState({
                        value: (this.props.selectedValueState)? this.props.selectedValueState: ''
                    })
                }
            }
        }
    }
    componentDidMount() {
        this.setState({
            financialSearch: this.props.financialData,
            value: (this.props.inputProps.value) ? this.props.inputProps.value.value : ''
        })
    }
    render() {
        const { id, placeholder, inputProps, required } = this.props;
        const { value, suggestions } = this.state;
        const inputProp = {
            placeholder,
            value: value,
            required: required ? true : false,
            onChange: this.onChange,
            disabled: inputProps.disabled,
            className: inputProps.className
        };
        return (
            <div>
                <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
                    <ModalBody>
                        Already Added
            </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.toggle}>Cancel</Button>
                    </ModalFooter>
                </Modal>
                <Autosuggest
                    id={id}
                    suggestions={suggestions}
                    onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                    onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                    getSuggestionValue={this.getSuggestionValue}
                    renderSuggestion={renderSuggestion}
                    inputProps={inputProp}
                    value={(id === 'stateSearch') ? inputProps.valueState : inputProp.value}
                    onSuggestionSelected={this.onSuggestionSelected}
                    className={this.props.className}
                    onChange={this.props.handleCountryAutocomplete}
                />
            </div>
        );
    }
}
const mapStateToProps = (state, ownProps) => ({
    id: ownProps.id,
    searchResults: state.autoSuggest.searchResults,
    searchKey: state.autoSuggest.searchKey,
    financialSearch: state.createScorecard.financialSearch,
    nonFinancialSearch: state.createScorecard.nonFinancialSearch
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    setSearchParameter: (search) => dispatch(setSearchParameter({ search: search, id: ownProps.id })),
    setSectionTemplateSearchParameter: (search) => dispatch(setSectionTemplateSearchParameter(search)),
    setOverriddingRiskFactorSearchParameter: (search) => { dispatch(setOverriddingRiskFactorSearchParameter(search)) },
    setScorecardSearchParameters: (search) => { dispatch(setScorecardSearchParameters(search)) },
    countryAutoComplete: (search) => { dispatch(countryAutoComplete(search)) },
    stateAutoComplete: (search) => { dispatch(stateAutoComplete(search)) }

});
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MyAutosuggest);
